import {
  CLEAR_EXERCISE_DIALOGUE,
  ExerciseActionsType,
  SET_EXERCISE_DIALOGUE,
  SET_EXERCISE_TO_DO,
  SET_EXERCISE_DONE, SET_EXERCISE_STATISTICS
} from './actions';

import {
  IExerciseActionHandler,
  IExerciseInitialState,
  IExerciseDialogue
} from './interfaces';

const ExerciseInitialState: IExerciseInitialState = {
  exerciseToDo: [],
  exerciseDone: [],
  exerciseDialogue: null,
  exerciseStatistics: []
};

const setExercisesToDo = ({
  state,
  payload
}: IExerciseActionHandler): IExerciseInitialState => {
  return {
    ...state,
    exerciseToDo: payload as IExerciseDialogue[]
  };
};

const setExercisesDone = ({
  state,
  payload
}: IExerciseActionHandler): IExerciseInitialState => {
  return {
    ...state,
    exerciseDone: payload as IExerciseDialogue[]
  };
};

const setExerciseDialogue = ({
  state,
  payload
}: IExerciseActionHandler): IExerciseInitialState => {
  return {
    ...state,
    exerciseDialogue: payload as IExerciseDialogue
  };
};

const clearExerciseDialogue = ({
  state
}: IExerciseActionHandler): IExerciseInitialState => {
  return {
    ...state,
    exerciseDialogue: null
  };
};

const setExerciseStatistics = ({
  state,
  payload
}: IExerciseActionHandler): IExerciseInitialState => {
  return {
    ...state,
    exerciseStatistics: payload as string[]
  };
};

const exerciseReducerHandlers = new Map([
  [SET_EXERCISE_TO_DO, setExercisesToDo],
  [SET_EXERCISE_DONE, setExercisesDone],
  [SET_EXERCISE_DIALOGUE, setExerciseDialogue],
  [CLEAR_EXERCISE_DIALOGUE, clearExerciseDialogue],
  [SET_EXERCISE_STATISTICS, setExerciseStatistics]
]);

const exerciseReducer = (
  state = ExerciseInitialState,
  action: ExerciseActionsType
): IExerciseInitialState => {
  const handler = exerciseReducerHandlers.get(action.type);

  return (
    handler && {
      ...handler(<IExerciseActionHandler>{
        state,
        payload: action.payload
      })
    }
  ) || {...state};
};

export default exerciseReducer;
